import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { CircleLoader } from "../../components/CircleLoader";
import styles from "./Loader.module.scss";
// this component is for bug DESP-81458, not yet DS compliant, will be updated
export const Loader = () => {
    return (_jsx("div", { className: classNames("hero-loader", styles.loader), children: _jsx(CircleLoader, {}) }));
};
//# sourceMappingURL=Loader.js.map